"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPortfolioCovenantResultsParams = void 0;
const formula_engine_1 = require("@finley-technologies/formula-engine");
const utils_1 = require("./utils");
const createPortfolioCovenantResultsParams = ({ dataAccessor, }) => {
    const { parameterConfig, variables } = dataAccessor;
    const { reportingPeriod, reportingDateFormula } = parameterConfig;
    try {
        const reportingDate = formula_engine_1.commonFormulas.evaluateDateFormula({
            dateFormula: reportingDateFormula.params.formula,
            variables,
        });
        return {
            isValid: true,
            params: {
                reportingDate,
                reportingPeriod: reportingPeriod.params,
            },
        };
    }
    catch (err) {
        return {
            isValid: false,
            errors: (0, utils_1.handleParamsError)(err, {
                prefix: '"createPortfolioCovenantResultsParams" Error',
            }),
        };
    }
};
exports.createPortfolioCovenantResultsParams = createPortfolioCovenantResultsParams;
//# sourceMappingURL=portfolioCovenantResultsParams.js.map